import { Link } from 'react-router-dom';
import { Heart, Instagram, Facebook, Mail } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-pockett-light border-t border-border">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12">
          {/* Brand */}
          <div>
            <img 
              src="https://customer-assets.emergentagent.com/job_a5c2e806-76ac-45b9-a482-9007f3bbaad7/artifacts/3d5bnodj_Photoroom_20260131_061208.png" 
              alt="Pockett Designs" 
              className="h-16 w-auto mb-4"
            />
            <p className="text-muted-foreground leading-relaxed">
              Practical, playful fabric pieces handmade in Australia with care.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-pockett-gray mb-4">Quick Links</h4>
            <nav className="flex flex-col gap-2">
              <Link 
                to="/shop" 
                className="text-muted-foreground hover:text-pockett-purple transition-colors"
                data-testid="footer-shop-link"
              >
                Shop All
              </Link>
              <Link 
                to="/about" 
                className="text-muted-foreground hover:text-pockett-purple transition-colors"
                data-testid="footer-about-link"
              >
                About Us
              </Link>
              <Link 
                to="/shop?category=Bags" 
                className="text-muted-foreground hover:text-pockett-purple transition-colors"
                data-testid="footer-bags-link"
              >
                Bags
              </Link>
              <Link 
                to="/shop?category=Baby Items" 
                className="text-muted-foreground hover:text-pockett-purple transition-colors"
                data-testid="footer-baby-link"
              >
                Baby Items
              </Link>
              <Link 
                to="/shop?category=Accessories" 
                className="text-muted-foreground hover:text-pockett-purple transition-colors"
                data-testid="footer-accessories-link"
              >
                Accessories
              </Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading font-semibold text-pockett-gray mb-4">Connect</h4>
            <div className="flex gap-4 mb-4">
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-white border border-border flex items-center justify-center hover:border-pockett-purple hover:text-pockett-purple transition-colors"
                data-testid="social-instagram"
                aria-label="Instagram"
              >
                <Instagram className="h-5 w-5" />
              </a>
              <a 
                href="#" 
                className="w-10 h-10 rounded-full bg-white border border-border flex items-center justify-center hover:border-pockett-purple hover:text-pockett-purple transition-colors"
                data-testid="social-facebook"
                aria-label="Facebook"
              >
                <Facebook className="h-5 w-5" />
              </a>
              <a 
                href="mailto:p.designs@mail.com" 
                className="w-10 h-10 rounded-full bg-white border border-border flex items-center justify-center hover:border-pockett-purple hover:text-pockett-purple transition-colors"
                data-testid="social-email"
                aria-label="Email"
              >
                <Mail className="h-5 w-5" />
              </a>
            </div>
            <p className="text-sm text-muted-foreground">
              hello@pockettdesigns.com
            </p>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} Pockett Designs. All rights reserved.
          </p>
          <p className="text-sm text-muted-foreground flex items-center gap-1">
            Made with <Heart className="h-4 w-4 text-pockett-pink fill-pockett-pink" /> in Australia
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
